<div
  class="box-border flex flex-col items-center h-full gap-3 py-5 px-9 bg-white"
>
  <div class="flex justify-start items-center w-[1223px] min-h-[29.33px]">
    <!-- Close element -->
    <button
      type="button"
      class="grid grid-flow-col gap-2 items-center justify-start"
      (click)="close.emit()"
    >
      <ui-icon name="chevron-left" fill="neutrals-600" m-size="24" size="24" />
      <ui-paragraph type="p14" mobile-type="p14" text-color="neutrals-600">
        Regresar
      </ui-paragraph>
    </button>
  </div>
  <form
    [formGroup]="form"
    *ngIf="!isLoadingQuote && quote"
    class="box-border flex flex-col items-center justify-start h-[600px] max-h-[600px] w-[1223px] bg-white border-neutrals-300 rounded-[8px] pt-10 overflow-y-auto"
  >
    <div class="flex flex-col gap-6 w-[1180px]">
      <div class="flex justify-between">
        <div class="flex flex-col gap-1 items-start">
          <ui-headline
            font-weight="semibold"
            type="h32"
            mobile-type="h32"
            text-color="neutrals-900"
          >
            Cotización
          </ui-headline>
          <ui-paragraph type="p14" mobile-type="p14" text-color="neutrals-900">
            N° {{ quote.quoteNumber }}
          </ui-paragraph>
        </div>
        <div class="flex items-center gap-4">
          <img class="h-[48px]" src="unacem-logo.png" alt="UNACEM logo" />
          <img class="h-[48px]" src="unicon-logo.png" alt="Unicon logo" />
        </div>
      </div>

      <!-- Primera fila: Detalles de Facturación, Detalles del contacto, Asesor -->
      <div class="grid grid-cols-4 gap-4 w-full">
        <!-- Detalles de Facturación -->
        <div
          formGroupName="sectionBilling"
          [ngClass]="{
            'border-[#D6D9E0]': !editBillingDetail,
            'border-unicon-yellow-100': editBillingDetail,
          }"
          class="col-span-2 border-[1px] box-border p-6 bg-white rounded-[11px] flex flex-col items-start gap-4"
        >
          <div class="flex justify-between w-full">
            <ui-paragraph
              type="p16"
              mobile-type="p16"
              text-color="neutrals-900"
              font-weight="semibold"
            >
              Detalles de Facturación
            </ui-paragraph>
            <button
              type="button"
              (click)="onEditBillingDetail()"
              class="cursor-pointer"
              *ngIf="!editBillingDetail"
            >
              <ui-icon name="edit" fill="neutrals-600" m-size="16" size="16" />
            </button>
            <div class="flex gap-2 items-center" *ngIf="editBillingDetail">
              <button
                (click)="onCancelBillingDetail()"
                class="h-[30px] w-[30px] cursor-pointer rounded-[6px] border border-[#D6D9E0] bg-white flex items-center justify-center"
                type="button"
              >
                <ui-icon
                  name="close"
                  fill="neutrals-600"
                  m-size="14"
                  size="14"
                />
              </button>
              <button
                (click)="onSaveEdit()"
                class="w-[60px] h-[30px] cursor-pointer bg-unicon-yellow-100 px-2 rounded-[6px] flex items-center justify-center"
                type="button"
              >
                <ui-paragraph
                  *ngIf="!isLoadingBillingDetail"
                  type="p10"
                  mobile-type="p10"
                  text-color="neutrals-0"
                  font-weight="regular"
                >
                  Guardar
                </ui-paragraph>
                <ui-loader
                  *ngIf="isLoadingBillingDetail"
                  type="secondary"
                  size="xl"
                />
              </button>
            </div>
          </div>
          <div class="box-border w-full flex flex-col gap-3">
            <div class="flex gap-[6px]">
              <ui-paragraph
                type="p14"
                mobile-type="p16"
                text-color="neutrals-700"
                font-weight="regular"
                class="basis-40 shrink-0"
                [content]="
                  quote.leadIdentificationDocumentTypeName
                    ? quote.leadIdentificationDocumentTypeName + ' :'
                    : 'DNI:'
                "
              />
              <div
                class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100 w-full"
                #documentNumberBox
              >
                <input
                  #billingFirstInput
                  type="text"
                  formControlName="documentNumber"
                  [attr.maxLength]="maxLength"
                  (focus)="
                    documentNumberBox.classList.toggle('border-neutrals-900')
                  "
                  (blur)="
                    documentNumberBox.classList.toggle('border-neutrals-900')
                  "
                />
              </div>
            </div>

            <div class="flex gap-[6px]">
              <ui-paragraph
                type="p14"
                mobile-type="p16"
                text-color="neutrals-700"
                font-weight="regular"
                class="basis-40 shrink-0"
                [content]="
                  quote.leadIdentificationDocumentTypeId === 2
                    ? 'Razón social: '
                    : 'Nombres: '
                "
              />
              <div
                *ngIf="!editBillingDetail"
                class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100 w-full"
                #nameBox
              >
                <input
                  type="text"
                  formControlName="name"
                  (focus)="nameBox.classList.toggle('border-neutrals-900')"
                  (blur)="nameBox.classList.toggle('border-neutrals-900')"
                />
              </div>
              <div *ngIf="editBillingDetail" class="flex w-full gap-3">
                <div
                  class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100 w-full"
                  #leadNameBox
                >
                  <input
                    type="text"
                    formControlName="leadName"
                    (focus)="
                      leadNameBox.classList.toggle('border-neutrals-900')
                    "
                    (blur)="leadNameBox.classList.toggle('border-neutrals-900')"
                  />
                </div>
                <div
                  *ngIf="editBillingDetail"
                  class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100 w-full"
                  #firstNameBox
                >
                  <input
                    type="text"
                    formControlName="firstName"
                    (focus)="
                      firstNameBox.classList.toggle('border-neutrals-900')
                    "
                    (blur)="
                      firstNameBox.classList.toggle('border-neutrals-900')
                    "
                  />
                </div>
                <div
                  *ngIf="editBillingDetail"
                  class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100 w-full"
                  #secondNameBox
                >
                  <input
                    type="text"
                    formControlName="secondName"
                    (focus)="
                      secondNameBox.classList.toggle('border-neutrals-900')
                    "
                    (blur)="
                      secondNameBox.classList.toggle('border-neutrals-900')
                    "
                  />
                </div>
              </div>
            </div>

            <div class="flex gap-[6px]">
              <ui-paragraph
                type="p14"
                mobile-type="p16"
                text-color="neutrals-700"
                font-weight="regular"
                class="basis-40 shrink-0"
                [content]="
                  quote.leadIdentificationDocumentTypeId === 2
                    ? 'Dirección fiscal: '
                    : 'Dirección: '
                "
              />
              <div
                *ngIf="!editBillingDetail"
                class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100 w-full"
                #addressBox
              >
                <input
                  type="text"
                  formControlName="address"
                  (focus)="addressBox.classList.toggle('border-neutrals-900')"
                  (blur)="addressBox.classList.toggle('border-neutrals-900')"
                />
              </div>
              <div *ngIf="editBillingDetail" class="flex w-full flex-col gap-2">
                <div class="grid grid-cols-3 gap-3 mt-3">
                  <div
                    class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
                    #departmentBox
                  >
                    <input
                      type="text"
                      placeholder="Departamento"
                      formControlName="department"
                      (focus)="
                        departmentBox.classList.toggle('border-neutrals-900')
                      "
                      (blur)="
                        departmentBox.classList.toggle('border-neutrals-900')
                      "
                    />
                  </div>
                  <div
                    class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
                    #provinceBox
                  >
                    <input
                      type="text"
                      placeholder="Provincia"
                      formControlName="province"
                      (focus)="
                        provinceBox.classList.toggle('border-neutrals-900')
                      "
                      (blur)="
                        provinceBox.classList.toggle('border-neutrals-900')
                      "
                    />
                  </div>
                  <div
                    class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
                    #districtBox
                  >
                    <input
                      type="text"
                      placeholder="Distrito"
                      formControlName="district"
                      (focus)="
                        districtBox.classList.toggle('border-neutrals-900')
                      "
                      (blur)="
                        districtBox.classList.toggle('border-neutrals-900')
                      "
                    />
                  </div>
                </div>
                <div
                  *ngIf="editBillingDetail"
                  class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100 w-full"
                  #addressBillingBox
                >
                  <input
                    type="text"
                    formControlName="addressBilling"
                    placeholder="Dirección"
                    (focus)="
                      addressBillingBox.classList.toggle('border-neutrals-900')
                    "
                    (blur)="
                      addressBillingBox.classList.toggle('border-neutrals-900')
                    "
                  />
                </div>
              </div>
            </div>
            <div class="flex gap-[6px]">
              <ui-paragraph
                type="p14"
                mobile-type="p16"
                text-color="neutrals-700"
                font-weight="regular"
                class="basis-40 shrink-0"
              >
                Fecha de cotización:
              </ui-paragraph>
              <div
                class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100 w-full"
                #dateBox
              >
                <input
                  type="text"
                  formControlName="date"
                  dateFormat
                  (focus)="dateBox.classList.toggle('border-neutrals-900')"
                  (blur)="dateBox.classList.toggle('border-neutrals-900')"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Detalles del contacto -->
        <div
          formGroupName="sectionContact"
          [ngClass]="{
            'border-[#D6D9E0]': !editContactDetails,
            'border-unicon-yellow-100': editContactDetails,
          }"
          class="border-[1px] box-border p-6 bg-white rounded-[11px] flex flex-col items-start gap-4"
        >
          <div class="flex justify-between w-full">
            <ui-paragraph
              type="p16"
              mobile-type="p16"
              text-color="neutrals-900"
              font-weight="semibold"
            >
              Detalles del contacto
            </ui-paragraph>
            <button
              (click)="onEditContactDetails()"
              class="cursor-pointer"
              *ngIf="!editContactDetails"
              type="button"
            >
              <ui-icon name="edit" fill="neutrals-600" m-size="16" size="16" />
            </button>
            <div class="flex gap-2 items-center" *ngIf="editContactDetails">
              <button
                (click)="onCancelContactDetails()"
                class="h-[30px] w-[30px] cursor-pointer rounded-[6px] border border-[#D6D9E0] bg-white flex items-center justify-center"
                type="button"
              >
                <ui-icon
                  name="close"
                  fill="neutrals-600"
                  m-size="14"
                  size="14"
                />
              </button>
              <button
                (click)="onSaveContactDetails()"
                class="w-[60px] h-[30px] cursor-pointer bg-unicon-yellow-100 px-2 rounded-[6px] flex items-center justify-center"
                type="button"
              >
                <ui-paragraph
                  *ngIf="!isLoadingContactDetails"
                  type="p10"
                  mobile-type="p10"
                  text-color="neutrals-0"
                  font-weight="regular"
                >
                  Guardar
                </ui-paragraph>
                <ui-loader
                  *ngIf="isLoadingContactDetails"
                  type="secondary"
                  size="xl"
                />
              </button>
            </div>
          </div>
          <div class="box-border w-full flex flex-col gap-3">
            <div
              class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100 w-full"
              #contactNameBox
            >
              <ui-icon
                class="flex-none"
                name="user"
                fill="neutrals-600"
                m-size="16"
                size="16"
              />
              <input
                #contactFirstInput
                type="text"
                formControlName="contactName"
                (focus)="contactNameBox.classList.toggle('border-neutrals-900')"
                (blur)="contactNameBox.classList.toggle('border-neutrals-900')"
              />
            </div>
            <div
              class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100 w-full"
              #contactPhoneBox
            >
              <ui-icon
                class="flex-none"
                name="phone"
                fill="neutrals-600"
                m-size="16"
                size="16"
              />
              <input
                type="text"
                formControlName="contactPhone"
                (focus)="
                  contactPhoneBox.classList.toggle('border-neutrals-900')
                "
                (blur)="contactPhoneBox.classList.toggle('border-neutrals-900')"
              />
            </div>
            <div
              class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100 w-full"
              #contactEmailBox
            >
              <ui-icon
                class="flex-none"
                name="message"
                fill="neutrals-600"
                m-size="16"
                size="16"
              />
              <input
                type="text"
                formControlName="contactEmail"
                (focus)="
                  contactEmailBox.classList.toggle('border-neutrals-900')
                "
                (blur)="contactEmailBox.classList.toggle('border-neutrals-900')"
              />
            </div>
          </div>
        </div>

        <!-- Asesor -->
        <div
          formGroupName="sectionAgent"
          [ngClass]="{
            'border-[#D6D9E0]': !editAdvisor,
            'border-unicon-yellow-100': editAdvisor,
          }"
          class="border-[1px] box-border p-6 bg-white rounded-[11px] flex flex-col items-start gap-4"
        >
          <div class="flex justify-between w-full">
            <ui-paragraph
              type="p16"
              mobile-type="p16"
              text-color="neutrals-900"
              font-weight="semibold"
            >
              Asesor
            </ui-paragraph>
          </div>
          <div class="box-border w-full flex flex-col gap-3">
            <div
              class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100 w-full"
              #agentNameBox
            >
              <ui-icon
                class="flex-none"
                name="user"
                fill="neutrals-600"
                m-size="16"
                size="16"
              />
              <input
                type="text"
                formControlName="agentName"
                (focus)="agentNameBox.classList.toggle('border-neutrals-900')"
                (blur)="agentNameBox.classList.toggle('border-neutrals-900')"
              />
            </div>
            <div
              class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100 w-full"
              #agentPhoneBox
            >
              <ui-icon
                class="flex-none"
                name="phone"
                fill="neutrals-600"
                m-size="16"
                size="16"
              />
              <input
                type="text"
                formControlName="agentPhone"
                (focus)="agentPhoneBox.classList.toggle('border-neutrals-900')"
                (blur)="agentPhoneBox.classList.toggle('border-neutrals-900')"
              />
            </div>
            <div
              class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100 w-full"
              #agentEmailBox
            >
              <ui-icon
                class="flex-none"
                name="message"
                fill="neutrals-600"
                m-size="16"
                size="16"
              />
              <input
                type="text"
                formControlName="agentEmail"
                (focus)="agentEmailBox.classList.toggle('border-neutrals-900')"
                (blur)="agentEmailBox.classList.toggle('border-neutrals-900')"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Dirección de entrega -->
      <div
        *ngIf="!hasBaggedOrBeamProductsValue"
        formGroupName="sectionShipping"
        [ngClass]="{
          'border-[#D6D9E0]': !editDispatchDetails,
          'border-unicon-yellow-100': editDispatchDetails,
        }"
        class="border-[1px] box-border p-6 bg-white rounded-[11px] flex flex-col items-start gap-4"
      >
        <div class="flex justify-between w-full">
          <ui-paragraph
            type="p16"
            mobile-type="p16"
            text-color="neutrals-900"
            font-weight="semibold"
          >
            Dirección de entrega
          </ui-paragraph>
          <button
            (click)="onEditDispatchDetails()"
            class="cursor-pointer"
            *ngIf="!editDispatchDetails"
            type="button"
          >
            <ui-icon name="edit" fill="neutrals-600" m-size="16" size="16" />
          </button>
          <div class="flex gap-2 items-center" *ngIf="editDispatchDetails">
            <button
              (click)="onCancelDispatchDetails()"
              class="h-[30px] w-[30px] cursor-pointer rounded-[6px] border border-[#D6D9E0] bg-white flex items-center justify-center"
              type="button"
            >
              <ui-icon name="close" fill="neutrals-600" m-size="14" size="14" />
            </button>
            <button
              (click)="onSaveDispatchDetails()"
              class="w-[60px] h-[30px] cursor-pointer bg-unicon-yellow-100 px-2 rounded-[6px] flex items-center justify-center"
              type="button"
            >
              <ui-paragraph
                *ngIf="!isLoadingDispatchDetails"
                type="p10"
                mobile-type="p10"
                text-color="neutrals-0"
                font-weight="regular"
              >
                Guardar
              </ui-paragraph>
              <ui-loader
                *ngIf="isLoadingDispatchDetails"
                type="secondary"
                size="xl"
              />
            </button>
          </div>
        </div>
        <div class="box-border w-full flex flex-col gap-3">
          <div
            *ngIf="!editDispatchDetails"
            class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100 w-full"
            #shippingAddressBox
          >
            <ui-icon
              class="flex-none"
              name="gps"
              fill="neutrals-600"
              m-size="16"
              size="16"
            />
            <input
              type="text"
              formControlName="shippingAddress"
              (focus)="
                shippingAddressBox.classList.toggle('border-neutrals-900')
              "
              (blur)="
                shippingAddressBox.classList.toggle('border-neutrals-900')
              "
            />
          </div>
          <div *ngIf="editDispatchDetails" class="grid grid-flow-row gap-2">
            <div
              class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px] border-neutrals-100"
              #dispatchDepartmentBox
            >
              <ui-icon name="gps" size="16" mSize="16" fill="neutrals-600" />
              <select
                formControlName="dispatchDepartment"
                (focus)="onFocusDepartment()"
                (blur)="dispatchDepartmentBox.classList.remove('focussed')"
                (change)="onSelectDepartment($event)"
              >
                <option [ngValue]="null" disabled selected hidden>
                  Departamento
                </option>
                <option
                  *ngFor="let department of departments"
                  [value]="department"
                >
                  {{ department }}
                </option>
              </select>
            </div>
            <div
              class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
              #dispatchProvinceBox
            >
              <ui-icon name="gps" size="16" mSize="16" fill="neutrals-600" />
              <select
                formControlName="dispatchProvince"
                (focus)="dispatchProvinceBox.classList.add('focussed')"
                (blur)="dispatchProvinceBox.classList.remove('focussed')"
                (change)="onSelectProvince($event)"
              >
                <option [ngValue]="null" disabled selected hidden>
                  Provincia
                </option>
                <option *ngFor="let province of provinces" [value]="province">
                  {{ province }}
                </option>
              </select>
            </div>
            <div
              class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
              #dispatchDistrictBox
            >
              <ui-icon name="gps" size="16" mSize="16" fill="neutrals-600" />
              <select
                formControlName="dispatchDistrict"
                (focus)="dispatchDistrictBox.classList.add('focussed')"
                (blur)="dispatchDistrictBox.classList.remove('focussed')"
                (change)="onSelectDistrict($event)"
              >
                <option [ngValue]="null" disabled selected hidden>
                  Distrito
                </option>
                <option *ngFor="let district of districts" [value]="district">
                  {{ district }}
                </option>
              </select>
            </div>
            <div
              class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
              #addressNameBox
            >
              <ui-icon name="gps" size="16" mSize="16" fill="neutrals-600" />
              <input
                type="text"
                placeholder="Dirección"
                formControlName="addressName"
                (focus)="onFocusAddress()"
                (blur)="addressNameBox.classList.toggle('border-neutrals-900')"
              />
            </div>
            <div class="flex items-center justify-center my-3">
              <ui-paragraph
                type="p14"
                mobile-type="p14"
                text-color="neutrals-500"
                font-weight="regular"
              >
                o
              </ui-paragraph>
            </div>
            <div
              class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
              #latitudeBox
            >
              <ui-icon
                name="location"
                size="16"
                mSize="16"
                fill="neutrals-600"
              />
              <input
                type="text"
                placeholder="Latitud"
                formControlName="latitude"
                (focus)="onFocusLatitude()"
                (blur)="latitudeBox.classList.toggle('border-neutrals-900')"
              />
            </div>
            <div
              class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
              #longitudeBox
            >
              <ui-icon
                name="location"
                size="16"
                mSize="16"
                fill="neutrals-600"
              />
              <input
                type="text"
                placeholder="Longitud"
                formControlName="longitude"
                (focus)="onFocusLongitude()"
                (blur)="longitudeBox.classList.toggle('border-neutrals-900')"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Datos de entrega Section -->
      <div
        *ngIf="
          hasBaggedOrBeamProductsValue &&
          (shouldShowFreightZoneValue ||
            shouldShowUnloadingMethodValue ||
            quote.shipping.freightZoneId !== null ||
            quote.shipping.unloadingMethodId !== null)
        "
        class="border-[1px] border-neutrals-300 box-border p-6 bg-neutrals-0 rounded-[11px] flex flex-col items-start gap-4"
      >
        <div class="flex justify-between w-full">
          <ui-paragraph
            type="p16"
            mobile-type="p16"
            text-color="neutrals-900"
            font-weight="semibold"
          >
            Datos de entrega
          </ui-paragraph>
        </div>

        <div class="box-border w-full flex flex-col gap-3">
          <div class="flex gap-2 items-center w-full">
            <ui-paragraph
              type="p14"
              mobile-type="p14"
              text-color="neutrals-700"
              font-weight="medium"
              class="basis-32 shrink-0"
            >
              Dirección :
            </ui-paragraph>
            <div
              class="bg-neutrals-100 flex-1 flex items-center justify-between px-3 py-2 rounded-[8px]"
            >
              <ui-paragraph
                type="p14"
                mobile-type="p14"
                text-color="neutrals-900"
                font-weight="medium"
              >
                {{ getShippingAddress() }}
              </ui-paragraph>
              <button
                type="button"
                (click)="onEditDispatchDetails()"
                class="cursor-pointer flex-none"
              >
                <ui-icon
                  name="edit"
                  fill="neutrals-600"
                  m-size="16"
                  size="16"
                />
              </button>
            </div>
          </div>

          <div
            *ngIf="
              quote.shipping.freightZoneId !== null ||
              quote.shipping.unloadingMethodId !== null
            "
            class="flex items-center justify-between w-full"
            [class.gap-4]="
              quote.shipping.freightZoneId !== null &&
              quote.shipping.unloadingMethodId !== null
            "
          >
            <div
              *ngIf="quote.shipping.freightZoneId !== null"
              class="w-full flex gap-2 items-start"
            >
              <ui-paragraph
                type="p14"
                mobile-type="p14"
                text-color="neutrals-700"
                font-weight="medium"
                class="basis-[70px] shrink-0 flex items-center h-[28px]"
              >
                Sector :
              </ui-paragraph>
              <div
                class="bg-neutrals-100 flex items-center justify-between px-3 py-2 rounded-[8px] flex-1 h-[28px]"
                [ngClass]="{
                  'w-full':
                    shouldShowSectorTariff() && !shouldShowUnloadingTariff(),
                }"
              >
                <ui-paragraph
                  type="p14"
                  mobile-type="p14"
                  text-color="neutrals-900"
                  font-weight="medium"
                >
                  {{ getSelectedFreightZoneName() }}
                </ui-paragraph>
                <button
                  type="button"
                  (click)="onEditFreightZone()"
                  class="cursor-pointer"
                >
                  <ui-icon
                    name="edit"
                    fill="neutrals-600"
                    m-size="16"
                    size="16"
                  />
                </button>
              </div>
            </div>

            <div
              *ngIf="quote.shipping.unloadingMethodId !== null"
              class="flex gap-2 items-start"
              [ngClass]="{
                'w-1/2':
                  quote.shipping.freightZoneId !== null &&
                  quote.shipping.unloadingMethodId !== null,
              }"
            >
              <ui-paragraph
                type="p14"
                mobile-type="p14"
                text-color="neutrals-700"
                font-weight="medium"
                class="shrink-0 flex items-center h-[28px]"
              >
                Método de descarga:
              </ui-paragraph>
              <div
                class="bg-neutrals-100 flex items-center justify-between px-3 py-2 rounded-[8px] flex-1 h-[28px]"
              >
                <ui-paragraph
                  type="p14"
                  mobile-type="p14"
                  text-color="neutrals-900"
                  font-weight="medium"
                >
                  {{ getSelectedUnloadingMethodName() }}
                </ui-paragraph>
                <button
                  type="button"
                  (click)="onEditUnloadingMethod()"
                  class="cursor-pointer"
                >
                  <ui-icon
                    name="edit"
                    fill="neutrals-600"
                    m-size="16"
                    size="16"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Flete de envío section -->
        <div
          *ngIf="shouldShowFreightZoneValue"
          class="border border-unicon-yellow-100 bg-white box-border p-6 rounded-[8px] w-full flex flex-col gap-4"
        >
          <div class="flex justify-between items-center w-full">
            <div class="flex flex-col gap-3">
              <ui-paragraph
                type="p16"
                mobile-type="p16"
                text-color="neutrals-900"
                font-weight="semibold"
              >
                Flete de envio
              </ui-paragraph>
              <ui-paragraph
                type="p12"
                mobile-type="p12"
                text-color="neutrals-900"
                font-weight="regular"
              >
                Selecciona uno de las opciones
              </ui-paragraph>
            </div>
            <button
              *ngIf="quote?.shipping?.freightZoneId !== null"
              type="button"
              (click)="onRemoveFreightZone()"
              class="cursor-pointer"
            >
              <ui-icon name="close" fill="neutrals-600" m-size="24" size="24" />
            </button>
          </div>

          <div class="grid grid-cols-2 gap-4">
            <div
              *ngIf="isLoadingFreightZones"
              class="col-span-2 flex justify-center items-center py-8"
            >
              <ui-loader type="secondary" size="2xl" />
            </div>
            <div
              *ngFor="let option of shippingFreightOptions"
              class="bg-neutrals-0 border border-neutrals-400 rounded-[16px] p-4 cursor-pointer hover:border-unicon-yellow-100 transition-colors"
              [class.border-unicon-yellow-100]="
                selectedShippingFreight === option.id
              "
              [class.bg-[#FFF7E0]="selectedShippingFreight === option.id"
              (click)="onShippingFreightChange(option.id)"
            >
              <div class="flex gap-4 items-start">
                <div class="relative shrink-0 size-[20px] mt-1">
                  <div
                    class="size-full rounded-full border-2 flex items-center justify-center"
                    [class.border-[#F7CD46]]="
                      selectedShippingFreight === option.id
                    "
                    [class.border-neutrals-400]="
                      selectedShippingFreight !== option.id
                    "
                  >
                    <div
                      *ngIf="selectedShippingFreight === option.id"
                      class="size-2 rounded-full bg-unicon-yellow-100"
                    ></div>
                  </div>
                </div>
                <div class="flex flex-col gap-2 flex-1">
                  <ui-paragraph
                    type="p14"
                    mobile-type="p14"
                    text-color="neutrals-900"
                    font-weight="semibold"
                  >
                    {{ option.name }}
                  </ui-paragraph>
                  <ui-paragraph
                    type="p14"
                    mobile-type="p14"
                    text-color="neutrals-900"
                    font-weight="regular"
                    class="whitespace-pre-line"
                  >
                    {{ option.description }}
                  </ui-paragraph>
                  <!-- <ui-paragraph
                    type="p14"
                    mobile-type="p14"
                    text-color="neutrals-900"
                    font-weight="bold"
                  >
                    S/ {{ option.price.toFixed(2) }}
                  </ui-paragraph> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Método de descarga section (only for bagged products) -->
        <div
          *ngIf="shouldShowUnloadingMethodValue"
          class="border border-unicon-yellow-100 bg-white box-border p-6 rounded-[8px] w-full flex flex-col gap-4"
        >
          <div class="flex justify-between items-center w-full">
            <div class="flex flex-col gap-3">
              <ui-paragraph
                type="p16"
                mobile-type="p16"
                text-color="neutrals-900"
                font-weight="semibold"
              >
                Método de descarga
              </ui-paragraph>
              <ui-paragraph
                type="p12"
                mobile-type="p12"
                text-color="neutrals-900"
                font-weight="regular"
              >
                Selecciona uno de las opciones
              </ui-paragraph>
            </div>
            <button
              *ngIf="quote?.shipping?.unloadingMethodId !== null"
              type="button"
              (click)="onRemoveUnloadingMethod()"
              class="cursor-pointer"
            >
              <ui-icon name="close" fill="neutrals-600" m-size="24" size="24" />
            </button>
          </div>

          <div class="grid grid-cols-2 gap-4">
            <div
              *ngIf="isLoadingUnloadingMethods"
              class="w-full col-span-2 flex justify-center items-center py-10"
            >
              <ui-loader type="secondary" size="2xl" />
            </div>
            <div
              *ngFor="let method of unloadingMethodOptions"
              class="bg-neutrals-0 border border-neutrals-400 rounded-[16px] p-4 cursor-pointer hover:border-unicon-yellow-100 transition-colors"
              [class.border-unicon-yellow-100]="
                selectedUnloadingMethod === method.id
              "
              [class.bg-unicon-yellow-100]="
                selectedUnloadingMethod === method.id
              "
              (click)="onUnloadingMethodChange(method.id)"
            >
              <div class="flex gap-4 items-start">
                <div class="relative shrink-0 size-[20px] mt-1">
                  <div
                    class="size-full rounded-full border-2 flex items-center justify-center"
                    [class.border-[#F7CD46]]="
                      selectedUnloadingMethod === method.id
                    "
                    [class.border-neutrals-400]="
                      selectedUnloadingMethod !== method.id
                    "
                  >
                    <div
                      *ngIf="selectedUnloadingMethod === method.id"
                      class="size-2 rounded-full bg-unicon-yellow-100"
                    ></div>
                  </div>
                </div>
                <div class="flex flex-col gap-2 flex-1">
                  <ui-paragraph
                    type="p14"
                    mobile-type="p14"
                    text-color="neutrals-900"
                    font-weight="semibold"
                  >
                    {{ method.name }}
                  </ui-paragraph>
                  <ui-paragraph
                    type="p14"
                    mobile-type="p14"
                    text-color="neutrals-900"
                    font-weight="regular"
                  >
                    {{ method.description }}
                  </ui-paragraph>
                  <!--  <ui-paragraph
                    type="p14"
                    mobile-type="p14"
                    text-color="neutrals-900"
                    font-weight="bold"
                  >
                    S/ {{ method.price.toFixed(2) }}
                  </ui-paragraph> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-4">
        <div
          class="box-border p-6 bg-white rounded-[11px] flex flex-col items-start gap-4"
          [ngClass]="{
            'border-[#D6D9E0] border': !errorMessage,
            'border-[#FA0A32] border': errorMessage,
          }"
        >
          <ui-paragraph
            type="p16"
            mobile-type="p16"
            text-color="neutrals-900"
            font-weight="semibold"
          >
            Detalle de la solicitud
          </ui-paragraph>

          <div class="box-border w-full flex flex-col gap-3">
            <!-- Header de tabla -->
            <div class="flex gap-3 mb-2">
              <div
                class="flex-grow flex justify-center items-center px-2 h-[36px] rounded-[6px] bg-neutrals-200"
              >
                <ui-paragraph
                  type="p12"
                  mobile-type="p12"
                  text-color="neutrals-900"
                  font-weight="semibold"
                >
                  Producto o Servicio
                </ui-paragraph>
              </div>
              <div
                class="flex justify-center w-[140px] items-center px-2 h-[36px] rounded-[6px] bg-neutrals-200"
              >
                <ui-paragraph
                  type="p12"
                  mobile-type="p12"
                  text-color="neutrals-900"
                  font-weight="semibold"
                >
                  Cantidad
                </ui-paragraph>
              </div>
              <div
                class="flex justify-center w-[140px] items-center px-2 h-[36px] rounded-[6px] bg-neutrals-200"
              >
                <ui-paragraph
                  type="p12"
                  mobile-type="p12"
                  text-color="neutrals-900"
                  font-weight="semibold"
                >
                  Precio Unit. (S/)
                </ui-paragraph>
              </div>
              <div
                class="flex justify-center w-[120px] items-center px-2 h-[36px] rounded-[6px] bg-neutrals-200"
              >
                <ui-paragraph
                  type="p12"
                  mobile-type="p12"
                  text-color="neutrals-900"
                  font-weight="semibold"
                >
                  Precio (S/)
                </ui-paragraph>
              </div>
            </div>

            <!-- Productos -->
            <div
              class="flex flex-col gap-3 mb-2"
              *ngFor="let product of quote.items"
            >
              <!-- Textos adicionales según el tipo de producto -->
              <div
                class="flex gap-3"
                *ngIf="shouldShowSectorTariff() || shouldShowUnloadingTariff()"
              >
                <div class="flex-grow"></div>
                <div class="w-[140px]"></div>
                <div class="w-[140px] flex flex-col gap-1">
                  <ui-paragraph
                    *ngIf="shouldShowSectorTariff()"
                    type="p12"
                    mobile-type="p12"
                    text-color="neutrals-500"
                    font-weight="regular"
                  >
                    Tarifa de Sector
                    {{
                      product.freightUnitPrice != null
                        ? 'S/ ' + product.freightUnitPrice.toFixed(2)
                        : ''
                    }}
                  </ui-paragraph>
                  <ui-paragraph
                    *ngIf="shouldShowUnloadingTariff()"
                    type="p12"
                    mobile-type="p12"
                    text-color="neutrals-500"
                    font-weight="regular"
                  >
                    Tarifa de descarga
                    {{
                      product.unloadingUnitPrice != null
                        ? 'S/ ' + product.unloadingUnitPrice.toFixed(2)
                        : ''
                    }}
                  </ui-paragraph>
                </div>
                <div class="w-[120px]"></div>
              </div>

              <!-- Fila principal del producto -->
              <div class="flex gap-3">
                <div
                  class="flex-grow flex justify-between items-center p-2 min-h-[36px] rounded-[6px] bg-neutrals-100"
                >
                  <ui-paragraph
                    type="p14"
                    mobile-type="p14"
                    text-color="neutrals-900"
                    font-weight="semibold"
                  >
                    {{ product.productVariantName }}
                  </ui-paragraph>
                  <button (click)="onDeleteProduct(product.id)">
                    <ui-icon
                      *ngIf="!isLoadingDelete"
                      name="delete"
                      size="16"
                      m-size="16"
                      fill="neutrals-500"
                    />
                    <ui-loader
                      *ngIf="isLoadingDelete"
                      type="secondary"
                      size="2xl"
                    />
                  </button>
                </div>
                <div
                  *ngIf="
                    product.id === editingQuantityProduct;
                    else viewModeQuantity
                  "
                  class="relative"
                >
                  <input
                    class="w-[140px] min-h-[36px] box-border py-2 px-4 rounded-[6px] bg-neutrals-100 focus:border-2 focus:border-solid focus:border-unicon-yellow-100 focus:outline-none"
                    type="number"
                    [formControl]="quoteQuantityControl"
                    (keydown.enter)="handleEditQuantity(product.id)"
                  />
                  <button
                    class="absolute inset-y-0 right-3 top-[6px] p-3 bg-unicon-yellow-100 rounded-[6px] h-7 w-7 flex items-center justify-center"
                    [ngClass]="{
                      'p-2': isLoadingQuantity,
                      'p-3': !isLoadingQuantity,
                    }"
                    (click)="handleEditQuantity(product.id)"
                  >
                    <ui-icon
                      *ngIf="!isLoadingQuantity"
                      name="check"
                      size="18"
                      m-size="18"
                      fill="neutrals-900"
                    />
                    <ui-loader
                      *ngIf="isLoadingQuantity"
                      type="secondary"
                      size="2xl"
                    />
                  </button>
                </div>

                <ng-template #viewModeQuantity>
                  <div
                    class="flex gap-2 justify-between items-center w-[140px] py-2 px-4 min-h-[36px] rounded-[6px] bg-neutrals-100"
                  >
                    <ui-paragraph
                      type="p14"
                      mobile-type="p14"
                      text-color="neutrals-900"
                    >
                      {{ product.quantity }}
                    </ui-paragraph>
                    <button (click)="onEditQuantity(product.id)">
                      <ui-icon
                        name="edit"
                        size="16"
                        m-size="16"
                        fill="neutrals-500"
                      />
                    </button>
                  </div>
                </ng-template>
                <div
                  *ngIf="product.id === editingProductId; else viewMode"
                  class="relative"
                >
                  <input
                    class="w-[140px] min-h-[36px] box-border py-2 px-4 rounded-[6px] bg-neutrals-100 focus:border-2 focus:border-solid focus:border-unicon-yellow-100 focus:outline-none"
                    type="number"
                    [formControl]="quoteUnitPriceControl"
                    (keydown.enter)="
                      $event.preventDefault();
                      $event.stopPropagation();
                      handleEditPrice(product.id)
                    "
                  />
                  <button
                    class="absolute inset-y-0 right-3 top-[6px] p-3 bg-unicon-yellow-100 rounded-[6px] h-7 w-7 flex items-center justify-center"
                    [ngClass]="{
                      'p-2': isLoadingPrice,
                      'p-3': !isLoadingPrice,
                    }"
                    (click)="handleEditPrice(product.id)"
                  >
                    <ui-icon
                      *ngIf="!isLoadingPrice"
                      name="check"
                      size="18"
                      m-size="18"
                      fill="neutrals-900"
                    />
                    <ui-loader
                      *ngIf="isLoadingPrice"
                      type="secondary"
                      size="2xl"
                    />
                  </button>
                </div>
                <ng-template #viewMode>
                  <div
                    class="flex gap-2 justify-between items-center w-[140px] py-2 px-4 min-h-[36px] rounded-[6px] bg-neutrals-100"
                    #priceFieldElement
                  >
                    <ui-paragraph
                      type="p14"
                      mobile-type="p14"
                      text-color="neutrals-900"
                    >
                      {{
                        product.unitPrice
                          | currency: 'S/ ' : 'symbol' : '1.2-2' : 'en'
                      }}
                    </ui-paragraph>
                    <button (click)="onEditPrice(product.id)">
                      <ui-icon
                        name="edit"
                        size="16"
                        m-size="16"
                        fill="neutrals-500"
                      />
                    </button>
                  </div>
                </ng-template>
                <div
                  class="flex justify-between items-center w-[120px] py-2 px-4 min-h-[36px] rounded-[6px] bg-neutrals-100"
                >
                  <ui-paragraph
                    type="p14"
                    mobile-type="p14"
                    text-color="neutrals-900"
                  >
                    {{
                      product.finalPrice
                        | currency: 'S/ ' : 'symbol' : '1.2-2' : 'en'
                    }}
                  </ui-paragraph>
                </div>
              </div>
            </div>
          </div>

          <!-- Botón agregar producto -->
          <div class="flex gap-3 mt-4 w-full">
            <unicon-add-product-multi-category
              *ngIf="add"
              class="w-full"
              (result)="onAddProduct($event, dataLead.id)"
              (cancel)="addItem()"
            />
            <button
              *ngIf="!add"
              type="button"
              class="flex justify-center items-center gap-2 btn-add-item rounded-[6px] py-2 px-4 box-border w-full"
              (click)="addItem()"
            >
              <ui-icon name="tag" fill="neutrals-900" m-size="20" size="20" />
              <ui-paragraph
                type="p12"
                mobile-type="p12"
                font-weight="semibold"
                text-color="neutrals-900"
              >
                Agregar producto
              </ui-paragraph>
            </button>
          </div>

          <ui-paragraph
            *ngIf="errorMessage"
            type="p12"
            mobile-type="p12"
            font-weight="semibold"
            text-color="critical-300"
            class="mt-2"
          >
            {{ message }}
          </ui-paragraph>
        </div>

        <div class="flex justify-end items-center">
          <div
            class="box-border flex flex-col justify-center items-center w-[408px]"
          >
            <div
              class="box-border bg-[#F5F5F7] rounded-tl-[6px] rounded-tr-[6px] px-4 py-2 w-full flex flex-col gap-4"
            >
              <div class="flex gap-9 box-border w-full px-3 py-1">
                <div class="flex-1 flex justify-end">
                  <ui-paragraph
                    type="p16"
                    mobile-type="p16"
                    text-color="neutrals-600"
                  >
                    Sub total
                  </ui-paragraph>
                </div>
                <div class="flex-1 flex justify-end">
                  <ui-paragraph
                    type="p16"
                    mobile-type="p16"
                    text-color="neutrals-900"
                    font-weight="semibold"
                  >
                    {{
                      quote.subTotalAmount
                        ? (quote.subTotalAmount
                          | currency: 'S/ ' : 'symbol' : '1.2-2' : 'en')
                        : 'S/ 0.0'
                    }}
                  </ui-paragraph>
                </div>
              </div>

              <div
                class="block w-full h-[1px] bg-neutrals-300 min-h-[1px]"
              ></div>

              <div class="flex flex-col gap-1">
                <div class="flex gap-9 box-border w-full px-3 py-1">
                  <div class="flex-1 flex justify-end">
                    <ui-paragraph
                      type="p16"
                      mobile-type="p16"
                      text-color="neutrals-600"
                    >
                      Total neto
                    </ui-paragraph>
                  </div>
                  <div class="flex-1 flex justify-end">
                    <ui-paragraph
                      type="p16"
                      mobile-type="p16"
                      text-color="neutrals-900"
                      font-weight="semibold"
                    >
                      {{
                        quote.netTotalAmount
                          ? (quote.netTotalAmount
                            | currency: 'S/ ' : 'symbol' : '1.2-2' : 'en')
                          : 'S/ 0.0'
                      }}
                    </ui-paragraph>
                  </div>
                </div>
                <div class="flex gap-9 box-border w-full px-3 py-1">
                  <div class="flex-1 flex justify-end">
                    <ui-paragraph
                      type="p16"
                      mobile-type="p16"
                      text-color="neutrals-600"
                    >
                      IGV %
                    </ui-paragraph>
                  </div>
                  <div class="flex-1 flex justify-end">
                    <ui-paragraph
                      type="p16"
                      mobile-type="p16"
                      text-color="neutrals-900"
                      font-weight="semibold"
                    >
                      {{
                        quote.taxAmount
                          ? (quote.taxAmount
                            | currency: 'S/ ' : 'symbol' : '1.2-2' : 'en')
                          : 'S/ 0.0'
                      }}
                    </ui-paragraph>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="box-border bg-unicon-yellow-100 rounded-bl-[6px] rounded-br-[6px] px-4 py-2 w-full flex flex-col"
            >
              <div class="flex gap-9 box-border w-full px-3 py-1">
                <div class="flex-1 flex justify-end">
                  <ui-paragraph
                    type="p16"
                    mobile-type="p16"
                    text-color="neutrals-0"
                    font-weight="bold"
                  >
                    Total
                  </ui-paragraph>
                </div>
                <div class="flex-1 flex justify-end">
                  <ui-paragraph
                    type="p16"
                    mobile-type="p16"
                    text-color="neutrals-0"
                    font-weight="bold"
                  >
                    {{
                      quote.totalAmount
                        ? (quote.totalAmount
                          | currency: 'S/ ' : 'symbol' : '1.2-2' : 'en')
                        : 'S/ 0.0'
                    }}
                  </ui-paragraph>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Detalles de despacho multi businessline -->
      <div
        class="grid grid-cols-3 gap-4 w-full"
        *ngIf="businessLines.length > 0"
      >
        <div
          *ngFor="let businessLine of businessLines"
          class="border-[1px] border-[#D6D9E0] box-border p-6 bg-white rounded-[11px] flex flex-col items-start gap-4"
        >
          <div class="flex justify-between w-full items-center">
            <ui-paragraph
              type="p16"
              mobile-type="p16"
              text-color="neutrals-900"
              font-weight="semibold"
            >
              Detalles del despacho {{ businessLine.businessLineName }}
            </ui-paragraph>
          </div>

          <div class="box-border w-full flex flex-col gap-3">
            <!-- Fecha -->
            <div class="flex items-center gap-3">
              <ui-icon
                class="flex-none"
                name="calendar"
                fill="neutrals-600"
                m-size="16"
                size="16"
              />
              <ui-paragraph
                type="p14"
                mobile-type="p14"
                text-color="neutrals-700"
                font-weight="regular"
              >
                {{ getFormattedDateForBusinessLine(businessLine) }}
              </ui-paragraph>
            </div>

            <!-- Hora -->
            <div class="flex items-center gap-3">
              <ui-icon
                class="flex-none"
                name="clock"
                fill="neutrals-600"
                m-size="16"
                size="16"
              />
              <ui-paragraph
                type="p14"
                mobile-type="p14"
                text-color="neutrals-700"
                font-weight="regular"
              >
                {{ getFormattedTimeRangeForBusinessLine(businessLine) }}
              </ui-paragraph>
            </div>
          </div>
        </div>
      </div>

      <div
        class="mt-6 border-[#D6D9E0] box-border p-6 bg-white rounded-[11px] flex flex-col items-start gap-4 border-[1px]"
      >
        <div class="flex flex-col gap-2 w-full">
          <ui-paragraph
            type="p16"
            mobile-type="p16"
            text-color="neutrals-900"
            font-weight="semibold"
          >
            Observaciones
          </ui-paragraph>

          <ui-paragraph
            type="p14"
            mobile-type="p14"
            text-color="neutrals-700"
            font-weight="regular"
          >
            Al aceptar la cotización y realizar el pago, declaro haber leído y
            aceptado las Condiciones Generales de Venta y del Servicio de Bombeo
            de Unión de Concreteras S.A.
            <a
              class="text-blue-600 underline hover:text-blue-800"
              href="https://www.unicon.com.pe/wp-content/uploads/CGV.pdf"
              target="_blank"
              >(disponibles en el siguiente link)</a
            >.
          </ui-paragraph>
          <ui-paragraph
            type="p14"
            mobile-type="p14"
            text-color="neutrals-700"
            font-weight="regular"
          >
            Condición de pago: Contado adelantado | Alcance de tubería de bomba:
            36ml | Volumen mín. de concreto: 6m3 | Volumen mín. de bombeo: 20m3
          </ui-paragraph>
        </div>
      </div>

      <div
        class="mt-6 bg-[#E8E9ED] border border-[#D6D9E0] rounded-[8px] px-6 py-4 w-full"
      >
        <p
          class="text-center text-sm font-medium text-black tracking-[-0.14px] font-['Poppins',sans-serif]"
        >
          Esta cotización es valida por 15 días a partir de la fecha
        </p>
      </div>

      <div
        class="w-full mt-6 flex items-center justify-end gap-8 px-6 py-5 border-t-neutrals-300 box-border"
      >
        <mat-checkbox
          class="unicon-checkbox"
          [(ngModel)]="pdfChecked"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="isLoadingSendQuote"
        >
          <span class="text-base font-medium text-neutrals-900">PDF</span>
        </mat-checkbox>

        <mat-checkbox
          class="unicon-checkbox"
          [(ngModel)]="imageChecked"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="isLoadingSendQuote"
        >
          <span class="text-base font-medium text-neutrals-900">Imagen</span>
        </mat-checkbox>

        <button
          type="button"
          (click)="onSendClick()"
          class="border-[1px] border-unicon-yellow-100 bg-unicon-yellow-100 h-[40px] min-w-[120px] px-5 box-border rounded-[6px] hover:opacity-75 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          [disabled]="isSendDisabled"
        >
          <ui-icon
            *ngIf="!isLoadingSendQuote"
            name="log-out"
            fill="neutrals-900"
            m-size="18"
            size="18"
          />
          <ui-paragraph
            *ngIf="!isLoadingSendQuote"
            type="p14"
            mobile-type="p14"
            text-color="neutrals-900"
            font-weight="semibold"
          >
            Enviar
          </ui-paragraph>
          <ui-loader *ngIf="isLoadingSendQuote" type="primary" size="2xl" />
        </button>
      </div>
    </div>
  </form>

  <div
    *ngIf="isLoadingQuote"
    class="box-border flex flex-col items-center justify-start h-[600px] max-h-[600px] w-[1223px] bg-neutrals-100 border-neutrals-300 rounded-[8px] pt-10 overflow-y-auto"
  >
    <div class="flex flex-col gap-6 w-[1015px]">
      <div class="flex flex-col gap-1 items-start">
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          [theme]="{ marginBottom: '0px', width: '200px', height: '32px' }"
        />
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          [theme]="{ marginBottom: '0px', width: '200px', height: '32px' }"
        />
      </div>

      <div class="flex flex-col gap-4">
        <div
          class="box-border p-6 bg-[#F5F5F7] border-[#D6D9E0] rounded-[11px] flex flex-col items-start gap-4"
        >
          <ngx-skeleton-loader
            count="1"
            appearance="line"
            [theme]="{ marginBottom: '0px', width: '200px', height: '32px' }"
          />

          <div class="box-border w-full flex flex-col gap-3">
            <div class="bg-neutrals-100 rounded-[8px] flex items-center gap-3">
              <ngx-skeleton-loader
                count="1"
                appearance="line"
                [theme]="{
                  marginBottom: '0px',
                  width: '965px',
                  height: '40px',
                }"
              />
            </div>
            <div class="flex gap-3">
              <div
                class="bg-neutrals-100 rounded-[8px] flex items-center gap-3 flex-[1]"
              >
                <ngx-skeleton-loader
                  count="1"
                  appearance="line"
                  [theme]="{
                    marginBottom: '0px',
                    width: '475px',
                    height: '40px',
                  }"
                />
              </div>
              <div
                class="bg-neutrals-100 rounded-[8px] flex items-center gap-3 flex-[1]"
              >
                <ngx-skeleton-loader
                  count="1"
                  appearance="line"
                  [theme]="{
                    marginBottom: '0px',
                    width: '475px',
                    height: '40px',
                  }"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          class="box-border p-6 bg-[#F5F5F7] border-[#D6D9E0] rounded-[11px] flex flex-col items-start gap-4"
        >
          <ngx-skeleton-loader
            count="1"
            appearance="line"
            [theme]="{ marginBottom: '0px', width: '200px', height: '32px' }"
          />

          <div class="box-border w-full flex flex-col gap-3">
            <div class="flex gap-3">
              <div
                class="flex-grow flex justify-center items-center rounded-[6px] bg-neutrals-200"
              >
                <ngx-skeleton-loader
                  count="1"
                  appearance="line"
                  [theme]="{
                    marginBottom: '0px',
                    width: '530px',
                    height: '40px',
                  }"
                />
              </div>
              <div
                class="flex justify-center w-[140px] items-center rounded-[6px] bg-neutrals-200"
              >
                <ngx-skeleton-loader
                  count="1"
                  appearance="line"
                  [theme]="{
                    marginBottom: '0px',
                    width: '140px',
                    height: '40px',
                  }"
                />
              </div>
              <div
                class="flex justify-center w-[140px] items-center rounded-[6px] bg-neutrals-200"
              >
                <ngx-skeleton-loader
                  count="1"
                  appearance="line"
                  [theme]="{
                    marginBottom: '0px',
                    width: '140px',
                    height: '40px',
                  }"
                />
              </div>
              <div
                class="flex justify-center w-[240px] items-center rounded-[6px] bg-neutrals-200"
              >
                <ngx-skeleton-loader
                  count="1"
                  appearance="line"
                  [theme]="{
                    marginBottom: '0px',
                    width: '120px',
                    height: '40px',
                  }"
                />
              </div>
            </div>
            <div class="flex gap-3" *ngFor="let a of arr">
              <div
                class="flex-grow flex justify-center items-center rounded-[6px] bg-neutrals-200"
              >
                <ngx-skeleton-loader
                  count="1"
                  appearance="line"
                  [theme]="{
                    marginBottom: '0px',
                    width: '530px',
                    height: '40px',
                  }"
                />
              </div>
              <div
                class="flex justify-center w-[140px] items-center rounded-[6px] bg-neutrals-200"
              >
                <ngx-skeleton-loader
                  count="1"
                  appearance="line"
                  [theme]="{
                    marginBottom: '0px',
                    width: '140px',
                    height: '40px',
                  }"
                />
              </div>
              <div
                class="flex justify-center w-[140px] items-center rounded-[6px] bg-neutrals-200"
              >
                <ngx-skeleton-loader
                  count="1"
                  appearance="line"
                  [theme]="{
                    marginBottom: '0px',
                    width: '140px',
                    height: '40px',
                  }"
                />
              </div>
              <div
                class="flex justify-center w-[240px] items-center rounded-[6px] bg-neutrals-200"
              >
                <ngx-skeleton-loader
                  count="1"
                  appearance="line"
                  [theme]="{
                    marginBottom: '0px',
                    width: '120px',
                    height: '40px',
                  }"
                />
              </div>
            </div>
            <div class="flex gap-3" *ngIf="!add">
              <button
                type="button"
                class="flex-grow flex justify-center h-[36px] items-center gap-2 btn-add-item rounded-[6px] py-2 px-4 box-border"
              ></button>
            </div>
          </div>
        </div>

        <div class="flex justify-end items-center">
          <div
            class="box-border flex flex-col justify-center items-center w-[408px]"
          >
            <div
              class="box-border bg-[#F5F5F7] rounded-tl-[6px] rounded-tr-[6px] px-4 py-2 w-full flex flex-col gap-4"
            >
              <div class="flex gap-9 box-border w-full px-3 py-1">
                <div class="flex-1 flex justify-end">
                  <ngx-skeleton-loader
                    count="1"
                    appearance="line"
                    [theme]="{
                      marginBottom: '0px',
                      width: '200px',
                      height: '32px',
                    }"
                  />
                </div>
                <div class="flex-1 flex justify-end">
                  <ngx-skeleton-loader
                    count="1"
                    appearance="line"
                    [theme]="{
                      marginBottom: '0px',
                      width: '120px',
                      height: '32px',
                    }"
                  />
                </div>
              </div>

              <div
                class="block w-full h-[1px] bg-neutrals-300 min-h-[1px]"
              ></div>

              <div class="flex flex-col gap-1">
                <div class="flex gap-9 box-border w-full px-3 py-1">
                  <div class="flex-1 flex justify-end">
                    <ngx-skeleton-loader
                      count="1"
                      appearance="line"
                      [theme]="{
                        marginBottom: '0px',
                        width: '200px',
                        height: '32px',
                      }"
                    />
                  </div>
                  <div class="flex-1 flex justify-end">
                    <ngx-skeleton-loader
                      count="1"
                      appearance="line"
                      [theme]="{
                        marginBottom: '0px',
                        width: '120px',
                        height: '32px',
                      }"
                    />
                  </div>
                </div>
                <div class="flex gap-9 box-border w-full px-3 py-1">
                  <div class="flex-1 flex justify-end">
                    <ngx-skeleton-loader
                      count="1"
                      appearance="line"
                      [theme]="{
                        marginBottom: '0px',
                        width: '200px',
                        height: '32px',
                      }"
                    />
                  </div>
                  <div class="flex-1 flex justify-end">
                    <ngx-skeleton-loader
                      count="1"
                      appearance="line"
                      [theme]="{
                        marginBottom: '0px',
                        width: '120px',
                        height: '32px',
                      }"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              class="box-border bg-unicon-yellow-100 rounded-bl-[6px] rounded-br-[6px] px-4 py-2 w-full flex flex-col"
            >
              <div class="flex gap-9 box-border w-full px-3 py-1">
                <div class="flex-1 flex justify-end">
                  <ngx-skeleton-loader
                    count="1"
                    appearance="line"
                    [theme]="{
                      marginBottom: '0px',
                      width: '200px',
                      height: '32px',
                    }"
                  />
                </div>
                <div class="flex-1 flex justify-end">
                  <ngx-skeleton-loader
                    count="1"
                    appearance="line"
                    [theme]="{
                      marginBottom: '0px',
                      width: '120px',
                      height: '32px',
                    }"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
